module.exports = __webpack_public_path__ + "static/img/college4.bd94f53.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college4.jpeg
// module id = F7Co
// module chunks = 45